import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7677f814"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "f7-icons size-22" }, "globe", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("言語")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("日本語")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("英語")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "login-status" }, "メールアドレスを宿泊予定者のアドレスに修正して、\"更新\"ボタンを押してください。")
], -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 更新")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f7_button = _resolveComponent("f7-button")!
  const _component_f7_nav_right = _resolveComponent("f7-nav-right")!
  const _component_f7_navbar = _resolveComponent("f7-navbar")!
  const _component_f7_actions_label = _resolveComponent("f7-actions-label")!
  const _component_f7_actions_button = _resolveComponent("f7-actions-button")!
  const _component_f7_actions_group = _resolveComponent("f7-actions-group")!
  const _component_f7_actions = _resolveComponent("f7-actions")!
  const _component_f7_list_input = _resolveComponent("f7-list-input")!
  const _component_f7_list = _resolveComponent("f7-list")!
  const _component_f7_block = _resolveComponent("f7-block")!
  const _component_f7_col = _resolveComponent("f7-col")!
  const _component_f7_page = _resolveComponent("f7-page")!

  return (_openBlock(), _createBlock(_component_f7_page, { style: {"background-color":"#FFF"} }, {
    default: _withCtx(() => [
      _createVNode(_component_f7_navbar, {
        title: "メールアドレスの変更",
        "back-link": "戻る"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f7_nav_right, null, {
            default: _withCtx(() => [
              _createVNode(_component_f7_button, {
                class: "col",
                raised: "",
                "actions-open": "#actions-one-group"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_f7_actions, { id: "actions-one-group" }, {
        default: _withCtx(() => [
          _createVNode(_component_f7_actions_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_f7_actions_label, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_f7_actions_button, { bold: "" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_f7_actions_button, null, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_5,
      _createVNode(_component_f7_list, {
        "no-hairlines": "",
        style: {"width":"85%","margin":"0 auto"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f7_list_input, {
            type: "text",
            outline: "",
            label: "メールアドレス（必須）",
            "floating-label": "",
            required: "",
            validate: "",
            "clear-button": ""
          })
        ]),
        _: 1
      }),
      _createVNode(_component_f7_col, {
        "no-hairlines": "",
        style: {"width":"80%","margin":"0 auto"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f7_block, null, {
            default: _withCtx(() => [
              _createVNode(_component_f7_button, {
                fill: "",
                large: "",
                href: "/:token/registration/changeEmailaddress/"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}